import { render } from "./MultiStepDuplicateInstanceForm.vue?vue&type=template&id=05c48ec7"
import script from "./MultiStepDuplicateInstanceForm.vue?vue&type=script&lang=js"
export * from "./MultiStepDuplicateInstanceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__